// API Configuration
export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL; // URL для разработки

// WebSocket Configuration
export const wsBaseUrl = process.env.REACT_APP_WS_BASE_URL; // WebSocket URL для разработки

// Функция для получения WebSocket URL с ID пользователя
export const getWebSocketURL = (userId: number): string => {
  return `${wsBaseUrl}/${userId}`;
};

// Дополнительные параметры API могут быть добавлены здесь
export const API_ENDPOINTS = {
  APPLICATIONS: '/api/applications',
  SPN: '/api/spn',
  REPEAT_SEARCH: '/api/spn/{spn_id}/repeat-search',
  SELECT_PRODUCT: '/api/spn/{spn_id}/select-product/{product_code}',
  DESELECT_PRODUCT: '/api/spn/{spn_id}/selected-product',
};